import { createReducer, on } from '@ngrx/store';
import { startLoading, stopLoading } from './loading.actions';

export interface LoadingState {
    activeRequests: number;
}

export const initialState: LoadingState = {
    activeRequests: 0,
};

export const loadingReducer = createReducer(
    initialState,
    on(startLoading, (state) => ({
        ...state,
        activeRequests: state.activeRequests + 1,
    })),
    on(stopLoading, (state) => ({
        ...state,
        activeRequests: Math.max(0, state.activeRequests - 1),
    }))
);
